import React, { FC } from 'react';
import s from './Template.scss';
import { Template as TemplateData } from '../../../../domain/entities/template';
import { TemplateImage } from '../../../TemplateImage/TemplateImage';
import { useBiLogger } from '../../../../contexts/BILoggerContext';
import { templateDataHooks } from './Template.dataHooks';
import { useOnViewportEnter } from '../../../../hooks/useOnViewportEnter';
import cs from 'classnames';

export interface TemplateProps {
  template: TemplateData;
  isLazyLoad?: boolean;
  index: number;
  className?: string;
}

export const Template: FC<TemplateProps> = ({
  template,
  isLazyLoad,
  index,
  className,
}) => {
  const biLogger = useBiLogger();
  const templateRef = useOnViewportEnter<HTMLDivElement>(() => {
    biLogger.reportAboveFoldImpression({ ...template, index });
  });

  return (
    <div
      className={cs(s.template, className)}
      data-hook={templateDataHooks.template({ key: template.templateId })}
      ref={templateRef}
    >
      <TemplateImage
        className={s.templateImage}
        isLazyLoad={isLazyLoad}
        template={template}
        index={index}
      />
      <div className={s.templateName}>{template.title}</div>
    </div>
  );
};
